// @ts-nocheck
import * as types from 'appRedux/actions/register';

const initialState = {
  request: false,
  success: false,
  error: '',
  message: '',
  roles: [],
};

function registerReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.REGISTER_USER_REQUEST:
      return {
        ...state,
        request: true,
      };

    case types.REGISTER_USER_SUCCESS:
      return {
        ...state,
        request: false,
        success: true,
        message: action.payload
          ? action.payload.message
          : 'You have been registered successfully.',
      };

    case types.GET_PERMISSION_ROLE_REQUEST:
      return {
        ...state,
        request: true,
      };
    case types.GET_PERMISSION_ROLE_SUCCESS:
      return {
        ...state,
        request: false,
        success: true,
        roles: action.payload ? action.payload.data : [],
      };
    default: {
      return state;
    }
  }
}
export default registerReducer;
